
async function getOdooFuelServices (traccar, from, to) {
  const url = `/odoo/reports/refuelingServices?startDate=${from.toDateString()}&endDate=${to.toDateString()}`

  try {
    const { data } = await traccar.axios.get(url, {
      jar: traccar.cookieJar,
      withCredentials: true
    })

    return data
  } catch (e) {
    console.log(e)
    return []
  }
}

exports.getOdooFuelServices = getOdooFuelServices
